<template>
    <div class="apple_group">
        <div class="create_list">
            <div class="create_title">Associated Group</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Associated Campaign Group：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['org_id'] != '' ? true : false}">
                    <el-select
                    v-model="form.org_id" 
                    placeholder="Enter campaign group ID or name keyword to search"
                    class="width460"
                    filterable
                    :loading="searchOrgLoading"
                    @visible-change="handleOrgFocus"
                    @change="handleOrgSelect"
                    ref="org_id"
                    size="mini"
                    :disabled="apple_create_type == 'editGroup' ? true : false"
                    >
                        <el-option
                            v-for="item in filterOrgOptions"
                            :key="item.value"
                            :label="item.label+'【'+item.value+'】'"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['org_id']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">Associated Campaign</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Associated Campaign：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['campaign_id'] != '' ? true : false}">
                    <el-tooltip placement="top" :disabled="form.org_id == '' ? false : true" :open-delay="500">
                        <div slot="content">Please select the associated campaign group first:</div>
                        <el-select
                            v-model="form.campaign_id" 
                            placeholder="Enter campaign name or ID keywords to search"
                            class="width460"
                            filterable
                            :loading="searchCampaignLoading"
                            :disabled="(form.org_id == '' || apple_create_type == 'editGroup') ? true : false"
                            @visible-change="handleCampaignFocus"
                            @change="handleCampaignSelect"
                            ref="campaign_id"
                            size="mini"
                            >
                                <el-option
                                    v-for="item in filterCampaignOptions"
                                    :key="item.value"
                                    :label="item.campaign_name+'【'+item.campaign_id+'】'"
                                    :value="item.campaign_id">
                                </el-option>
                            </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom">{{errorsMsg['campaign_id']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>

        <div v-if="getShow" v-loading="editLoading">

        <div class="create_divider">
            <h2>Ad Group</h2>
        </div>
        <div class="create_list">
            <div class="create_title">Basic Information</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Ad Group Name：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['adgroup_name'] != '' ? true : false}">
                    <div class="ad_name_flex">
                        <el-input
                            placeholder="Up to 200 characters. Special characters are not allowed."
                            v-model="form.adgroup_name"
                            :maxlength="200"
                            @input="handleAdNameInput(form.adgroup_name)"
                            @blur="handleAdName"
                            class="width460"
                            size="mini">
                        </el-input>
                        
                        <div class="num_length">{{form.adgroup_name.length}} / 200</div>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['adgroup_name']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">Search Matching
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                Search Match is the easiest way to get your ads up and running. We'll automatically match your ads with users who are searching for apps like yours. Search Match uses a variety of resources to automatically match your ads with relevant searches in the App Store, including metadata from your App Store details, information from similar apps in the same category, and other search data.
Tip: Optimize metadata and images.
When deciding which ads to display, relevance is a top priority, so be sure to carefully craft your app name, images, descriptions, and keywords to make them appealing and highly relevant. Take the time to review your related information. Changes made to app metadata, images, and any other applicable data may take up to 24 hours to appear in your ads.
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <span :style="{paddingRight: '8px'}">Automatically match my ads with relevant searches</span>
                        <el-switch v-model="form.automated_keywords_opt_in" active-value="1" inactive-value="0" size="mini"></el-switch>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_PRODUCT_PAGES_BROWSE'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">App Category：
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                               Your ads can be shown in all relevant app categories, and you can also refine the categories where your ads are displayed.
<br/>All categories: Display ads in all relevant app categories.
<br/>Similar categories: Display ads only in app categories similar to mine.
<br/>Other categories: Display ads only in app categories different from mine.</div>
                            <span class="questions">?</span>
                        </el-tooltip>
                    </span>
                </div>
                <div class="create_action">
                        <el-radio-group v-model="form.app_categories" size="mini">
                            <el-radio label="3">All Categories</el-radio>
                            <el-radio label="2">Similar Categories</el-radio>
                            <el-radio label="1">Other Categories</el-radio>
                        </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">Campaign Duration</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Campaign Dates：</span></div>
                <div class="create_action" :style="{flex: '0 0 800px'}">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <div>
                        <el-radio-group size="mini" v-model="tfdate" @change="handletfdate">
                            <el-radio-button label="1">Long-term Campaign</el-radio-button>
                            <el-radio-button label="2">Specify Start and End Dates</el-radio-button>
                        </el-radio-group>
                        </div>
                        <div>
                        <span class="font12px ml10 mr10 text-color-gray" v-if="form.time_zone=='Asia/Shanghai'">Time Zone - Shanghai</span>
                        <span class="font12px ml10 mr10 text-color-gray" v-else-if="form.time_zone=='UTC'">Time Zone - UTC</span>
                        <!-- <el-select :value="form.time_zone" placeholder="Please select" @change="changeTimeZone"
                            :style="{width: '120px', marginLeft: '8px', marginRight: '8px', border: 'none'}" size="mini">
                            <el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>
                            <el-option label="时区-UTC" value="UTC">时区-UTC</el-option>
                        </el-select> -->
                        </div>
                    </div>
                    
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action" :style="{flex: '0 0 800px'}">
                    <div>
                        <div class="mb20">
                            <span :style="{paddingRight: '8px', color: '#606266'}">Start Date：</span>
                            <el-date-picker
                                align="right"
                                type="date"
                                placeholder="Please select a date"
                                :style="{width: '180px'}"
                                v-model="tf_start.start_date"
                                :picker-options="pickerStartOptions"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :disabled="apple_create_type == 'editGroup'"
                                size="mini">
                            </el-date-picker>
                            <el-time-picker
                                value-format="HH:mm"
                                format="HH:mm"
                                :picker-options="{format:'HH:mm'}"
                                :style="{width: '130px', marginLeft: '8px'}"
                                v-model="tf_start.start_time"
                                placeholder="Please select a time"
                                :disabled="apple_create_type == 'editGroup'"
                                size="mini"
                                popper-class="de_time_picker">
                            </el-time-picker> 

                            <p class="create_err_bottom" :style="{paddingLeft: '68px'}">{{errorsMsg['tf_time']}}</p>
                        </div>

                        <div v-if="tfdate == 2" class="create_action_year" :class="{'is-error': errorsMsg['tf_time_2'] != '' ? true : false}">
                            <span :style="{paddingRight: '8px', color: '#606266'}">End Date：</span>
                            <el-date-picker
                                align="right"
                                type="date"
                                placeholder="Please select a date"
                                :style="{width: '180px'}"
                                v-model="tf_end.start_date"
                                :picker-options="pickerEndOptions"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                size="mini">
                            </el-date-picker>
                            <el-time-picker
                                value-format="HH:mm"
                                format="HH:mm"
                                :picker-options="{format:'HH:mm'}"
                                :style="{width: '130px', marginLeft: '8px'}"
                                v-model="tf_end.start_time"
                                placeholder="Please select a time"
                                size="mini"
                                popper-class="de_time_picker">
                            </el-time-picker>
                            <p class="create_err_bottom" :style="{paddingLeft: '68px'}">{{errorsMsg['tf_time_2']}}</p>
                        </div>
                    </div>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">Placement Period
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                Choose when to display ads to users. Placement time is based on the user's local time zone.
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="tftime">
                        <el-radio-button label="1">Unlimited</el-radio-button>
                        <el-radio-button label="2">Specify Time Period</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS' && tftime == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action" :style="{flex: '0 0 700px'}">
                    <div>
                        <DropTimes @getdaypart="getdaypart" ref="dropTimes"></DropTimes>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['daypart']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">Bid</div>
            <div class="create_item">
                <div class="create_label"><span class="star">*</span>
                    <span class="create_label_text">Default Maximum Cost-Per-Click Bid
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                Default Maximum Cost-Per-Click Bid<br/>
This is the highest amount you are willing to pay for each ad click. This bid will apply to all keywords within this ad group unless you set individual keyword bids.
Tip: Start with the average user value you know. For example: If you are willing to pay $2.50 to acquire a user and estimate that 40% of users who click the ad will download the app, you can pay 40% of $2.50 per click, which is $1.00.
                                </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action" :class="{'is-error': errorsMsg['default_bid_amount'] != '' ? true : false}">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <el-input 
                        v-model="form.default_bid_amount" 
                        @input="(value)=>handleInput(value, 'default_bid_amount')"
                        @blur="(event) => handleRequiredBlur(event, 'default_bid_amount', form.default_bid_amount)"
                        @change="handleamount"
                        placeholder="Please enter a bid amount, cannot exceed the campaign’s daily budget"
                        size="mini"
                        class="width460">
                        </el-input>
                        <span class="normal-text ml10">{{daily_budget_currency}}</span>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['default_bid_amount'] || getBIdAmountBottomErrorMsg}}</p>
                </div>
                <div class="create_err_right" :style="{paddingLeft: '8px'}">{{getBIdAmountErrorMsg}}</div>
            </div>
            <div class="create_item" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS'">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">maximum cost-per-conversion
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                            This optional setting specifies the amount you are willing to pay for each conversion and sets a maximum bid limit for all keywords in your ad group.
<br/><br/>The calculation for this cap is as follows: Maximum Cost-per-Conversion x Conversion Rate
<br/><br/>If the maximum cost-per-click bid for a keyword is lower than the result of the above formula, the system will apply that maximum cost-per-click bid.
<br/><br/>For example, if the maximum cost-per-conversion is $5 and the conversion rate is 65%, the system applies a maximum bid of $3.25 for all keywords in the ad group. If the maximum cost-per-click is set at $4, the system will still apply a maximum bid of $3.25.
<br/><br/>The maximum cost-per-conversion cap will limit the number of impressions and conversions; you can decide whether or not to make these settings.
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <el-input 
                        v-model="form.cpa_goal" 
                        @input="(value)=>handleInput(value, 'cpa_goal')"
                        placeholder="Please enter a bid amount, cannot exceed the campaign’s daily budget"
                        size="mini"
                        class="width460">
                        </el-input>
                        <span class="normal-text ml10">{{daily_budget_currency}}</span>
                    </div>
                    <p class="create_err_bottom">{{getCpaGoalErrorMsg}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list" v-if="supply_source == 'APPSTORE_SEARCH_RESULTS' && this.apple_create_type != 'editGroup'">
            <!-- v-if="supply_source == 'APPSTORE_SEARCH_TAB'" -->
            <div class="create_title">Keywords</div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">Add keywords
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                Keywords are relevant words or phrases that users may use when searching for apps like yours. You can bid on any keyword individually to optimize your return on investment. Broad match will automatically include variations such as synonyms and phrases containing the term, as well as common spelling mistakes and plural forms, so you don't need to add these.
                                <br/><br/><span :style="{fontWeight: 'bolder'}">Tip: Using search match</span>is a good way to discover relevant keywords that will increase the number of impressions, clicks, and conversions for your app, so you don't have to consider all possibilities.
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div>
                        <el-button type="text" @click="showKeywordModal">Click to Add</el-button>
                    （ {{keyword.length}}  Keywords Added to Ad Group）
                        <span v-if="this.apple_create_type != 'editGroup'" class="text-color-error pointer font12px ml20" @click="clearKeyword">Clear</span>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item">
                <div class="create_label"><span class="star"></span>
                    <span class="create_label_text">Add negative keyword
                        <el-tooltip
                            effect="dark"
                            placement="top"
                            :open-delay="500">
                            <div slot="content" :style="{width: '300px'}">
                                "Negative keywords prevent your ad from appearing in search results for those terms.
For example, if you add 'free' as a negative keyword, your ad will not appear in searches using the term 'free.' The negative keywords you add only apply to this ad group. Set negative keywords at the campaign level to apply them to all ad groups."
                            </div>
                            <span class="questions">?</span>
                        </el-tooltip>
                        ：
                    </span>
                </div>
                <div class="create_action">
                    <div>
                        <el-button type="text" @click="showNegativeKeywordModal">Click to Add</el-button>
                        （ {{negative_keyword.length}} Negative Keywords Added to Ad Group）
                        <span v-if="this.apple_create_type != 'editGroup'" class="text-color-error pointer font12px ml20" @click="clearNegativeKeyword">Clear</span>
                    </div>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
        </div>
        <div class="create_list">
            <div class="create_title">Audience</div>
            <!-- <div class="create_item">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">受众:</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="targeting_type">
                        <el-radio-button label="1">Unlimited</el-radio-button>
                        <el-radio-button label="2">特定受众</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div> -->
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Device：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['device_class'] != '' ? true : false}">
                    <el-select v-model="device_class" 
                    multiple
                    remote 
                    reserve-keyword 
                    collapse-tags
                    placeholder="Please select"
                    @change="(value)=>handleallchange(value, 'device_class')"
                    class="width460"
                    size="mini"
                    >
                        <el-option :label="item.label" :value="item.value" v-for="(item, index) in device_class_list" :key="index"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['device_class']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">User Type：</span></div>
                <div class="create_action" :class="{'is-error': errorsMsg['app_downloader'] != '' ? true : false}">
                    <el-select 
                    v-model="sz_Form.app_downloader" 
                    placeholder="Please select"
                    @change="(value)=>handleallchange(value, 'app_downloader')"
                    size="mini"
                    class="width460">
                        <!-- <el-option label="全部" value="3"></el-option>
                        <el-option label="新用户" value="1"></el-option>
                        <el-option label="我的其他APP的用户" value="4"></el-option>
                        <el-option label="回访用户" value="2"></el-option> -->
                        <el-option :label="item.label" :value="item.value" v-for="(item, index) in app_downloader_list" :key="index"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['app_downloader']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-show="targeting_type == '2' && sz_Form.app_downloader == '4'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <div :style="{display: 'flex', alignItems: 'center'}">
                        <div>
                            <el-button type="text" @click="handleSelectOutApp">Select My Other Apps
                                <el-tooltip
                                    effect="dark"
                                    placement="top"
                                    :open-delay="500"
                                    >
                                    <div slot="content">
                                        Cross-promote your app to users of one or more of your other apps.
                                    </div>
                                    <span class="questions">?</span>
                                </el-tooltip>
                            </el-button>
                        </div>
                        <span :style="{color: 'rgb(118 118 118)', paddingLeft: '8px'}">{{sz_Form.app_downloader_apps && sz_Form.app_downloader_apps.length}} other Apps added</span>
                    </div>
                    <p class="create_err_bottom">{{errorsMsg['outApp']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Gender：</span></div>
                <div class="create_action">
                    <el-select 
                    v-model="sz_Form.gender" 
                    class="width460"
                    placeholder="Please select"
                    @change="(value)=>handleallchange(value, 'gender')"
                    size="mini">
                        <el-option label="All" value=""></el-option>
                        <el-option label="Male" value="M"></el-option>
                        <el-option label="Female" value="F"></el-option>
                    </el-select>
                    <p class="create_err_bottom">{{errorsMsg['gender']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Age：</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="age_type">
                        <el-radio-button label="1">Unlimited</el-radio-button>
                        <el-radio-button label="2">Specify age range</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && age_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <div>
                        <el-select 
                        v-model="ageForm.start" 
                        placeholder="Please select"
                        :style="{width: '120px', marginRight: '10px'}"
                        @change="handleAgeStart"
                        class="create_action_year"
                        :class="{'is-error': errorsMsg['ageForm_start'] != '' ? true : false}"
                        size="mini">
                            <el-option :label="item" :value="item" v-for="(item, index) in startYear" :key="index"></el-option>
                        </el-select>
                        <span>-</span>
                        <el-select v-model="ageForm.end" 
                        placeholder="Please select"
                        :style="{width: '120px', marginLeft: '10px'}"
                        @change="handleAgeEnd"
                        class="create_action_year"
                        :class="{'is-error': errorsMsg['ageForm_end'] != '' ? true : false}"
                        size="mini">
                            <el-option :label="item" :value="item" v-for="(item, index) in endYear" :key="index"></el-option>
                            <el-option label="65+" :value="Number(65)"></el-option>
                        </el-select>
                    </div>
                    <p class="create_err_bottom posi">{{errorsMsg['ageForm_start']}}</p>
                    <p class="create_err_bottom posi" :style="{left: '144px'}">{{errorsMsg['ageForm_end']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" :style="{paddingBottom: '20px'}" v-if="targeting_type == '2'">
                <div class="create_label"><span class="star">*</span><span class="create_label_text">Geographical Location:：</span></div>
                <div class="create_action">
                    <el-radio-group size="mini" v-model="positioning_type">
                        <el-radio-button label="1">Unlimited</el-radio-button>
                        <el-radio-button label="2">Specify Geographical Location</el-radio-button>
                    </el-radio-group>
                    <p class="create_err_bottom">{{errorsMsg['country']}}</p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" :style="{paddingBottom: '10px'}" v-if="targeting_type == '2' && positioning_type == '2'">
                <p :style="{color: '#606266', paddingLeft: '220px'}">Please enter at least two characters to search for geographical locations</p>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>Country</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.country" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword
                        collapse-tags
                        :loading="searchCountryLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'country')"
                        placeholder="Search by country name"
                        :disabled="!ciryerror"
                        @change="(value)=>handleallchange(value, 'country')"
                        size="mini"
                        class="width460">
                            <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in countryOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>Province/Autonomous Region/Municipality</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.admin_area" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword
                        :loading="searchAdminLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'admin_area')"
                        collapse-tags
                        placeholder="Search by province/autonomous region/municipality name"
                        :disabled="!ciryerror"
                        @change="(value)=>handleallchange(value, 'admin_area')"
                        size="mini"
                        class="width460">
                        <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in areaOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>
            <div class="create_item" v-if="targeting_type == '2' && positioning_type == '2'">
                <div class="create_label"><span class="star"></span><span class="create_label_text"></span></div>
                <div class="create_action">
                    <p>City</p>
                    <el-tooltip placement="top" :disabled="ciryerror" :open-delay="500">
                        <div slot="content">
                            {{
                                ciryshow
                            }}
                        </div>
                        <el-select 
                        v-model="positioningForm.locality" 
                        multiple
                        filterable 
                        remote 
                        reserve-keyword 
                        collapse-tags
                        :loading="searchLocalityLoading"
                        :remote-method="(query) => remoteMethodCity(query, 'locality')"
                        placeholder="Search by city name"
                        @change="(value)=>handleallchange(value, 'locality')"
                        :disabled="!ciryerror"
                        size="mini"
                        class="width460">
                        <el-option :label="item.display_name" :value="item.id" v-for="(item, index) in localityOptions" :key="index"></el-option>
                        </el-select>
                    </el-tooltip>
                    <p class="create_err_bottom"></p>
                </div>
                <div class="create_err_right"></div>
            </div>

        </div>

        </div>

        <!-- 添加关键词 -->
        <keywordModal ref="keywordModal" 
        action-type="adGroupAddKeyword"
        :action-rows="keyword"
        :currency-text="daily_budget_currency"
        :form-data="actionRowData"
        @save="saveKeyword"
        />
        <!-- 添加否定关键词 -->
        <NegativeKeywordModal 
        ref="negativeKeywordModal" 
        action-type="adGroupAddNegativeKeyword"
        :action-rows="negative_keyword"
        :form-data="actionRowData"
        @save="saveNegativeKeyword"/>
        <!-- 选择我的其他App -->
        <appModal ref="appModal" :select="sz_Form.app_downloader_apps" @getOutApp="getOutApp"></appModal>
        <el-dialog
            :title="null"
            :visible.sync="dialogVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index-en';
    import DropTimes from '../components/dropTimes.vue'
    import appModal from './modal/appModal.vue'
    import keywordModal from '../keywords/modal/keywordModal';
    import NegativeKeywordModal from '../keywords/modal/negativeKeywordModal';
    import {
        get_create_ad_err_html,
        get_flag_suc_html
    } from "../components/getFlagHtml.js";
    import { throttle } from 'lodash'
    //                             o8888888o
    //                             88" . "88
    //                             (| -_- |)
    //                              O\ = /O
    //                           ____/`---'\____
    //                        .   ' \\| |// `.
    //                         / \\||| : |||// \
    //                        / _||||| -:- |||||- \
    //                         | | \\\ - /// | |
    //                       | \_| ''\---/'' | |
    //                        \ .-\__ `-` ___/-. /
    //                    ___`. .' /--.--\ `. . __
    //                  ."" '< `.___\_<|>_/___.' >'"".
    //                 | | : `- \`.;`\ _ /`;.`/ - ` : | |
    //                    \ \ `-. \_ __\ /__ _/ .-` / /
    //           ======`-.____`-.___\_____/___.-`____.-'======
    export default {
        name: 'create_apple_ad_group',
        components: {
            DropTimes,
            appModal,
            keywordModal,
            NegativeKeywordModal
        },
        props: ['org','campaign'],
        inject:['priceDecimalConfig'],
        data() {
            return {
                show:false,  //广告组是否显示
                editLoading: false,  //编辑loading
                disabled:true,
                pickerStartOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                pickerEndOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                filterOrgOptions: [],
                searchOrgLoading: false,
                filterCampaignOptions: [],
                searchCampaignLoading: false,
                prev_org_id: '',
                prev_campaign_id: '',
                supply_source: '',   //投放位置信息  很重要 处理 选项是否预算
                countries_or_regions: '', //位置国家 地区 很重要
                countries_or_regions_support_target:false, //是否支持  true 支持  false不支持
                prev_start_time: '',  //上一级广告组开始时间
                prev_end_time: '',    //上一级广告组结束时间
                form: {
                    org_id: '',        // 所属广告系列组
                    org_name: '',
                    campaign_id: '',  //所属广告系列
                    campaign_name: '',
                    adgroup_name: '',   //  广告组名称
                    automated_keywords_opt_in: '1',  // 搜索匹配 0是关 1是开
                    app_categories: '3',          //App 类别 3所有类别，2类似类别，1其他类别
                    time_zone: 'Asia/Shanghai',  //时区切换
                    start_time: '',      // 投放日期 开始日期
                    end_time: '',       // 投放日期 结束日期
                    daypart: [],       // 投放时段
                    default_bid_amount: '', //默认最高每次点击付费出价
                    cpa_goal: '',   //每次转化费用上限
                },
                keyword: [],     // 关键词
                negative_keyword: [],   //否定关键词
                tfdate: '1',      //投放日期 1 长期投放  2 指定开始和结束日期
                tftime: '1',       //投放时段
                targeting_type: '2',       // 受众   1不限  2特定受众
                age_type: '1',   //年龄 tab 切换
                positioning_type: '1',   //地理位置 tab 切换
                tf_start: {
                    start_date: '',     //投放日期 开始日期
                    start_time: '',     //投放日期 开始日期 时间
                },
                tf_end: {
                    start_date: '',       //投放日期 结束日期
                    start_time: '',       //投放日期 结束日期 时间
                },
                device_class: '',   //  全部 ['IPAD', 'IPHONE']  IPAD IPHONE  特殊处理
                device_class_list: [],
                app_downloader_list: [],  //用户类型
                sz_Form: {
                    app_downloader: '',   // 用户类型:3-所有用户,1-新用户,2-回访用户,4-我的其他APP
                    app_downloader_apps: [],  // 用户类型为我的其他APP时选择的产品
                    gender: ''              //M 男 F女
                },
                ageForm: {
                    start: '',
                    end: ''
                },
                startYear:[],
                endYear:[],
                positioningForm: {       
                    country: [],
                    admin_area: [],
                    locality: []
                },
                errorsMsg: {
                    org_id: '',
                    campaign_id: '',
                    adgroup_name: '',
                    tf_time: '',
                    tf_time_2: '',
                    daypart: '',
                    default_bid_amount:'',
                    device_class: '',
                    app_downloader: '',
                    outApp: '',
                    ageForm_start: '',
                    ageForm_end: '',
                    country: '',
                    admin_area: '',
                    locality: ''
                },   //错误的校验信息
                countryOptions: [],   //国家下拉框
                areaOptions: [],   //省 自治区
                localityOptions: [],   //城市下拉框
                avg_default_bid_amount: '',  //平均值
                daily_budget: 0,
                daily_budget_currency: 'RMB',  //单位
                cpa_goal:0,
                big_daily_budget : 0,
                errTips: 'Required fields cannot be empty',
                dialogVisible: false,   //各种错误提示
                dialogTypeTitle: '',
                apple_create_type: '',
                searchCountryLoading: false,
                searchAdminLoading: false,
                searchLocalityLoading: false,
                adgroup_id:'',
                adname_mul:false
            }
        },
        computed:{
            ...mapGetters(['cur_tab_page']),
            decimalConfig(){
                return this.priceDecimalConfig();
            },
            getShow: function() {
                if(this.form.campaign_id != '') {
                    return true
                }else{
                    return false
                }
            },
            getBIdAmountBottomErrorMsg: function() {
                if(Number(this.daily_budget) != 0 && Number(this.daily_budget) < Number(this.form.default_bid_amount)) {
                    return "Cannot exceed the parent campaign's budget, please re-enter"
                }else if(Number(this.big_daily_budget)  < Number(this.form.default_bid_amount)){
                    return 'Cannot exceed the default maximum bid, please re-enter'
                }
            },
            getBIdAmountErrorMsg: function() {
                if(Number(this.avg_default_bid_amount) < Number(this.form.default_bid_amount)) {
                    let average = Number(this.form.default_bid_amount) - Number(this.avg_default_bid_amount)
                    let pix = ( (( Number(this.form.default_bid_amount) - Number(this.avg_default_bid_amount) ) / Number(this.avg_default_bid_amount)) * 100).toFixed(2)
                    if(pix == 'Infinity') {
                        return ``
                    }else{
                        return `Entered bid exceeds the account’s average bid by ${average} ${this.daily_budget_currency}（${pix}%）,please verify!`
                    }
                }else{
                    return ''
                }
            },
            getCpaGoalErrorMsg: function() {
                if(Number(this.cpa_goal) != 0) {
                    if(Number(this.cpa_goal) < Number(this.form.cpa_goal)) {
                        return 'Cannot exceed the default maximum bid, please re-enter'
                    }
                    // if(Number(this.daily_budget) < Number(this.form.cpa_goal)) {
                    //     return 'Cannot exceed the parent campaign's budget, please re-enter'
                    // }
                }else{
                    return ''
                }
            },
            ciryerror: function() {
                let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2
                if(nums > 1 || !this.countries_or_regions_support_target) {
                    return false
                }else{
                    return true
                }
            },
            ciryshow: function() {
                let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2
                if(this.countries_or_regions_support_target) {
                    if(nums > 1) {
                        return 'Subdividing geolocation is not supported when placing ads in multiple countries or regions.'
                    }else{
                        return ''
                    }
                }else{
                    return 'The selected country or region does not support subdividing geolocation.'
                }
            },
            actionRowData(){
                return {
                    org_id:this.form.org_id,
                    org_name:this.filterOrgOptions.filter(item=>item['org_id'] == this.form.org_id).map(item=>item.org_name)[0],
                    campaign_id:this.form.campaign_id,
                    campaign_name:this.filterCampaignOptions.filter(item=>item['campaign_id'] == this.form.campaign_id).map(item=>item.campaign_name)[0]
                }
            },
        },
        watch: {
            'tf_start.start_date': {
                handler(newVal, oldVal) {
                    this.concat_start_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_start.start_time': {
                handler(newVal, oldVal) {
                    this.concat_start_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_end.start_date': {
                handler(newVal, oldVal) {
                    this.concat_end_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'tf_end.start_time': {
                handler(newVal, oldVal) {
                    this.concat_end_date();
                },
                immediate: true,
                deep: true, // 深度监听
            },
            'form.start_time': {
                handler(newVal, oldVal) {
                    this.handleRequiredDate()
                },
                deep: true, // 深度监听
            },
            'form.end_time': {
                handler(newVal, oldVal) {
                    this.handleRequiredDate()
                },
                deep: true, // 深度监听
            },
            'form.daypart'(newValue) {
                if(this.tftime == '2') {
                    let result_value = (Array.isArray(newValue) && newValue.length == 0) ? '' : newValue.length
                    this.validateItem('daypart', result_value, 
                        [
                            { required: true, message: 'Required fields cannot be empty'},
                        ]
                    );
                }
            },
            org: {
                handler(newVal, oldVal) {
                    // 在对象发生变化时执行的操作
                    if(newVal && newVal.list.length != 0 && this.apple_create_type != 'editGroup') {
                        this.filterOrgOptions = newVal.list
                        // this.prev_org_id = newVal['id'] ? newVal['id'].toString() : ''
                        this.form.org_id = newVal['id'] ? newVal['id'].toString() : ''
                        // this.form.org_id = newVal.list[0]['org_id']
                        if(this.form.org_id != '') {
                            this.prev_campaign_id = ''
                            this.form.campaign_id = '' 
                            this.handleCampaignFocus_new('')
                        }
                        
                    }else{
                        this.handleOrgFocus_new()
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            },
            campaign: {
                handler(newVal, oldVal) {
                    // 在对象发生变化时执行的操作
                    if(newVal && newVal.list.length != 0) {
                        // this.filterCampaignOptions = newVal.list
                        this.prev_campaign_id = newVal.list[0]['campaign_id'] ? newVal.list[0]['campaign_id'].toString() : ''
                        this.form.campaign_id =  newVal.list[0]['campaign_id'] ? newVal.list[0]['campaign_id'].toString() : ''
                        // this.getOutInfo(this.form.org_id, this.form.campaign_id)
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            }
        },

        mounted() {
            this.apple_create_type = this.$store.getters.apple_create_type
            // this.handleOrgFocus_new()
            if(this.apple_create_type == 'editGroup') {
                let editInfo = this.$store.getters.apple_edit_info
                // 获取编辑状态下的详情
                this.adgroup_id = editInfo['adgroup_id']
                this.getEditInfo(editInfo['org_id'], editInfo['adgroup_id'], editInfo['campaign_id'])
            }
            // 将滚动位置设置为页面顶部
            window.scrollTo(0, 0);
        },
        methods: {
            getEditInfo(org_id, adgroup_id, campaign_id) {
                this.$emit('postresult', {loading: true, dialog: false, success: false,});
                this.editLoading = true
                API.get_create_campaign_info({org_id: org_id, campaign_id: campaign_id}).then(res=>{
                    let result = res.data
                    this.form.time_zone = result.config['time_zone']
                    this.app_downloader_list = result['app_downloader_select_list'] ? result['app_downloader_select_list'].map(item=>{
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }) : []

                    this.daily_budget_currency = result.config.currency
                    this.daily_budget = result.daily_budget
                    this.cpa_goal = result.config.cpa_goal
                    this.big_daily_budget = result.config['default_bid_amount']

                    this.countries_or_regions = result['countries_or_regions']
                    this.countries_or_regions_support_target = result['countries_or_regions_support_target']
                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
                API.get_create_adgroup_info({org_id: org_id, adgroup_id: adgroup_id}).then(res=>{
                    let reslute = res.data

                    this.filterOrgOptions = [{value: reslute['org_id'], label: reslute['org_name']}]
                    this.filterCampaignOptions = [{campaign_id: reslute['campaign_id'], campaign_name: reslute['campaign_name']}]


                    this.form.org_id = reslute['org_id'] ? reslute['org_id'].toString() : ''
                    this.form.org_name = reslute['org_name']
                    this.form.campaign_id = reslute['campaign_id'] ? reslute['campaign_id'].toString() : ''
                    this.form.campaign_name = reslute['campaign_name']
                    this.supply_source = reslute['supply_source']
                    this.form.app_categories = reslute['app_categories'] ? reslute['app_categories'].toString() : ''

                    this.get_app_eligibility(reslute['adam_id'], reslute['org_id']).then(()=>{
                        this.form.adgroup_name = reslute['adgroup_name']
                        this.form.automated_keywords_opt_in = reslute['automated_keywords_opt_in']
                        
                        
                        
                        if(reslute['end_time']) {
                            this.tfdate = '2'

                            let split_data_start = reslute['start_time'] ? reslute['start_time'].split(' ') : ''
                            this.tf_start.start_date = split_data_start[0]
                            this.tf_start.start_time = split_data_start[1]

                            let split_data_end = reslute['end_time'] ? reslute['end_time'].split(' ') : ''
                            this.tf_end.start_date = split_data_end[0]
                            this.tf_end.start_time = split_data_end[1]

                            this.form.start_time = reslute['start_time']
                            this.form.end_time = reslute['end_time']

                        }else{
                            let split_data_start = reslute['start_time'] ? reslute['start_time'].split(' ') : ''
                            this.tf_start.start_date = split_data_start[0]
                            this.tf_start.start_time = split_data_start[1]

                            this.form.start_time = reslute['start_time']
                        }

                        if(reslute['daypart'] && reslute['daypart'].length != 0) {
                            this.tftime = '2'
                            
                            this.$nextTick(()=>{
                                this.form.daypart = reslute['daypart']
                                this.$refs.dropTimes.getIdToString(reslute['daypart'])
                            })
                        }

                        if(reslute['default_bid_amount']) {
                            this.form.default_bid_amount = reslute['default_bid_amount']
                        }
                        if(reslute['cpa_goal']) {
                            let zore_cpa_goal = (Number(reslute['cpa_goal']) === 0 || reslute['cpa_goal'] == '-') ? '' : reslute['cpa_goal']
                            this.form.cpa_goal = zore_cpa_goal
                        }
                        if(reslute['keyword']) {
                            this.keyword = reslute['keyword']
                        }
                        if(reslute['negative_keyword']) {
                            this.negative_keyword = reslute['negative_keyword']
                        }

                        if(reslute['device_class']) {
                            this.targeting_type = 2
                            // if(reslute['device_class'].length == 2) {
                            //     this.device_class = '1'
                            // }else{
                            //     this.device_class = reslute['device_class']
                            // }
                            this.device_class = reslute['device_class']
                        }

                        if(reslute['app_downloader'] && reslute['app_downloader'] == '4') {
                            this.sz_Form.app_downloader = reslute['app_downloader'] ? reslute['app_downloader'].toString() : ''
                            this.sz_Form.app_downloader_apps = reslute['app_downloader_apps'].map(item=>{
                                return {
                                    adam_id: item.adam_id ? item.adam_id.toString() : '',
                                    app_name: item.app_name
                                }
                            })
                        }else if(reslute['app_downloader'] && reslute['app_downloader'] != '4'){
                            this.sz_Form.app_downloader = reslute['app_downloader'] ? reslute['app_downloader'].toString() : ''
                        }

                        if(reslute['gender']) {
                            this.sz_Form.gender =  reslute['gender'] ? reslute['gender'].toString() : ''
                        }

                        if(reslute['age']) {
                            if(reslute['age'].length == 0) {
                                this.age_type = '1'
                            }else{
                                this.age_type = '2'
                                if(reslute['age'].length == 1) {
                                    this.ageForm.start = reslute['age'][0] ? reslute['age'][0].toString() : ''
                                    this.ageForm.end = 65
                                }else if(reslute['age'].length == 2){
                                    this.ageForm.start = reslute['age'][0] ? reslute['age'][0].toString() : ''
                                    this.ageForm.end = reslute['age'][1] ? reslute['age'][1].toString() : ''
                                }
                            }
                        }
                        
                        if(reslute['country'] && reslute['country'].length != 0) {
                            this.positioning_type = '2'
                            this.countryOptions = reslute['country']
                            this.positioningForm.country = reslute['country'].map(item=>item.id)
                        }
                        if(reslute['admin_area'] && reslute['admin_area'].length != 0) {
                            this.positioning_type = '2'
                            this.areaOptions = reslute['admin_area']
                            this.positioningForm.admin_area = reslute['admin_area'].map(item=>item.id)
                        }
                        if(reslute['locality'] && reslute['locality'].length != 0) {
                            this.positioning_type = '2'
                            this.localityOptions = reslute['locality']
                            this.positioningForm.locality = reslute['locality'].map(item=>item.id)
                        }
                        this.editLoading = false
                        this.$emit('postresult', {loading: false, dialog: false, success: false,});
                    })
                }, err=>{
                    this.editLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});
                })
            },
            getMsgTime() {
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let cday = date.getDate()
                return `${year}-${month}-${cday}`
            },
            // 清空重置
            resetForm() {
                this.errorsMsg.org_id = ''
                this.errorsMsg.campaign_id = ''
                this.errorsMsg.adgroup_name = ''
                this.errorsMsg.tf_time = ''
                this.errorsMsg.tf_time_2 = ''
                this.errorsMsg.daypart = ''
                this.errorsMsg.default_bid_amount =''
                this.errorsMsg.device_class = ''
                this.errorsMsg.app_downloader = ''
                this.errorsMsg.outApp = ''
                this.errorsMsg.ageForm_start = ''
                this.errorsMsg.ageForm_end = ''
                this.errorsMsg.country = ''
                this.errorsMsg.admin_area = ''
                this.errorsMsg.locality = ''

                this.positioningForm.country = '',
                this.positioningForm.admin_area = ''
                this.positioningForm.locality = ''

                this.ageForm.start = ''
                this.ageForm.end = ''

                // this.form.org_id= ''
                // this.form.campaign_id= ''
                this.form.adgroup_name= ''
                this.form.automated_keywords_opt_in= '1'
                this.form.app_categories= '3'
                this.form.time_zone= 'Asia/Shanghai'
                // this.form.start_time= ''
                this.form.end_time= ''
                this.form.daypart= []
                this.form.default_bid_amount= ''
                this.form.cpa_goal= ''

                this.tfdate = '1'
                this.tftime = '1'
                this.targeting_type = '2'
                this.age_type = '1'
                this.positioning_type = '1'
            },
            // 单独校验
            validateItem(fieldName, value, rules) {
                // this.errorsMsg[fieldName] = '';
                // this.$set(this.errorsMsg, fieldName, '');
                try {
                    rules.forEach(item=> {
                            if (item['required'] && !value) {
                                this.errorsMsg[fieldName] = item.message
                                console.log(fieldName, item.message)
                                throw('终止')
                            }else{
                                if(item['max'] && value.length > item['max']) {
                                    this.errorsMsg[fieldName] = item.message
                                }else if(item['reg']) {
                                    let reg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|[^\x00-\x7F\xA0-\uD7FF\uE000-\uFFFF]/;
                                    let otherReg = /^[^[\];{}"<>]*$/;
                                    if(reg.test(value) || !otherReg.test(value)) {
                                        this.errorsMsg[fieldName] = item.message
                                    }
                                }else{
                                    this.errorsMsg[fieldName] = ''
                                }
                            }
                    })
                } catch(e) { console.log('e',e) }
            },
            // 校验清空
            clearValidateItem(fieldName) {
                this.errorsMsg[fieldName] = ''
            },
            // 触发校验
            handleRequiredBlur(event, validateName, current_value) {
                let result_value = event.target.value || current_value
                this.validateItem(validateName, result_value, 
                    [
                        { required: true, message: 'Required fields cannot be empty'},
                    ]
                );
            },
            // 投放日期 校验
            handleRequiredDate() {
                if(this.tfdate == 1) {
                    let result_start = 1000000000000000000

                    if(this.tf_start.start_date && this.tf_start.start_time) {
                        result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                    }else{
                        result_start = 0
                    }

                    let prev_endtime = this.prev_end_time ? new Date(this.prev_end_time).valueOf() : 0

                    let validateName = 'tf_time'
                    let result_value = ''
                    let msg = ''
                    if(prev_endtime != 0 && result_start > prev_endtime) {
                        msg = 'Start date and time cannot exceed the end date and time of the parent campaign'
                    }else if(result_start == 0){
                        msg = 'Required fields cannot be empty'
                    }else{
                        result_value = '10'
                        msg = ''

                    }
                    this.validateItem(validateName, result_value, 
                        [
                            { required: true, message: msg},
                        ]
                    );
                    return
                }
                let prev_starttime = this.prev_start_time ? new Date(this.prev_start_time).valueOf() : 0

                let result_start = 1000000000000000000
                let result_end = 1000000000000000000
                if(this.tf_start.start_date && this.tf_start.start_time) {
                    result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                }else{
                    result_start = 0
                }

                if(this.tf_end.start_date && this.tf_end.start_time) {
                    result_end = this.form.end_time ? new Date(this.form.end_time).valueOf() : 0
                }else{
                    result_end = 0
                }

                let validateName = 'tf_time_2'
                let result_value = ''
                let msg = 'Required fields cannot be empty'
                if(result_start != 0 && result_end != 0) {
                    if(result_start >= result_end) {
                        this.errorsMsg.tf_time_2 = ''
                        msg = 'End date cannot be earlier than the start date and time'
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }else if(prev_starttime != 0 && prev_starttime > result_end) {
                        this.errorsMsg.tf_time_2 = ''
                        msg = 'End date and time cannot be earlier than the start date and time of the parent campaign'
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }else{
                        this.errorsMsg.tf_time_2 = ''
                        result_value = '10'
                        msg = ''
                        this.validateItem(validateName, result_value, 
                            [
                                { required: true, message: msg},
                            ]
                        );
                    }
                }else{
                    result_value = ''
                    msg = 'Required fields cannot be empty'
                    this.validateItem('tf_time_2', result_value, 
                        [
                            { required: true, message: msg},
                        ]
                    );
                }
                
            },
            // 所属广告系列组 
            handleOrgFocus_new() {
                if(this.filterOrgOptions.length == 0) {
                    this.searchOrgLoading = true
                    API.getOrgSelectorList({ search: '',source_page:this.cur_tab_page }).then(res => {
                        let result = res.data ? res.data : []
                        // this.filterOrgOptions = result
                        let resultList = result.map(item=>{
                            return {
                                value:item.org_id,
                                label:item.org_name,
                            }
                        });
                        // this.prev_org_id = this.form.org_id
                        this.$emit('postOrg', {
                            id: '',
                            list: resultList
                        })
                        this.searchOrgLoading = false
                    },err => {
                        this.searchOrgLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$emit('postOrg', {
                            id: '',
                            list: []
                        })
                        this.$message.error(err.info);
                    })
                } 
            },
            // 所属广告系列组 下拉
            remoteMethodOrg(query) {
                if (query == '') {
                    return
                }
                this.searchOrgLoading = true
                API.getOrgSelectorList({ search: query,source_page:this.cur_tab_page, }).then(res => {
                    let result = res.data ? res.data : []
                    // this.filterOrgOptions = result
                    let resultList = result.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.$emit('postOrg', {
                        id: '',
                        list: resultList
                    })
                    this.searchOrgLoading = false
                },err => {
                    this.searchOrgLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 缓存上一次选择
            handleOrgFocus(val) {
                // if (val) {
                //     console.log('shangyici', this.form.org_id, val)
                //     this.prev_org_id = this.form.org_id
                // }
            },
            // 所属广告系列组 change 事件
            handleOrgSelect(value) {
                if(this.form.campaign_id != '') {
                    this.$confirm('Modifying the campaign group will clear all entered content', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        CancelButtonText: 'Close',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                        }).then(() => {
                            this.$refs.org_id.blur()
                            this.resetForm()
                            this.clearValidateItem('org_id')

                            this.form.org_id = value
                            this.$emit('postOrg', {
                                id: this.form.org_id,
                                list: this.filterOrgOptions
                            })

                        }).catch(() => {
                            console.log('000', this.prev_org_id)
                            this.form.org_id = this.prev_org_id
                            this.$refs.org_id.blur()
                            // this.loading = false
                            // this.$emit('postOrg', {
                            //     id: this.prev_org_id,
                            //     list: this.filterOrgOptions
                            // })
                    });
                }else {
                    this.resetForm()
                    this.clearValidateItem('org_id')
                    this.form.org_id = value
                    this.$emit('postOrg', {
                        id: this.form.org_id,
                        list: this.filterOrgOptions
                    })

                }
                // console.log('-000', value)
                // this.form.org_id = value
                // let org_item = this.filterOrgOptions.filter(item=>item.org_id == value)
                // this.$emit('postresult', {loading: false, dialog: false, success: false, org_list: {type:'group' ,list:org_item}})
                // this.$emit('postOrg', {
                //     id: this.form.org_id,
                //     list: this.filterOrgOptions
                // })
                // API.getCampaignSelectorList({ search: '', org_id: value,source_page:this.cur_tab_page}).then(res => {
                //     let result = res.data
                //     this.filterCampaignOptions = result
                //     this.form.campaign_id = ''
                //     this.searchCampaignLoading = false
                // },err => {
                //     this.searchCampaignLoading = false
                //     this.$message.error(err.info);
                // })
                // this.form.org_id = value

            },
            handleCampaignFocus_new(query) {
                this.prev_org_id = this.form.org_id
                this.searchCampaignLoading = true
                API.getCampaignSelectorList({ search: query,source_page:this.cur_tab_page, org_id: this.form['org_id']}).then(res => {
                    let result = res.data
                    this.filterCampaignOptions = result

                    if(this.form.campaign_id) {
                        let ispull = this.filterCampaignOptions.some(item=>item.campaign_id == this.form.campaign_id)
                        if(ispull) {
                            this.getOutInfo(this.form.org_id, this.form.campaign_id)
                        }
                    }else{
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, org_list: {type:'group' ,list:org_item}})
                    }
                    this.searchCampaignLoading = false
                },err => {
                    this.searchCampaignLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 所属广告系列 下拉
            remoteMethodCampaign(query) {
                if (query == '') {
                    return
                }
                this.searchCampaignLoading = true
                API.getCampaignSelectorList({ search: query,source_page:this.cur_tab_page, org_id: this.form['org_id']}).then(res => {
                    let result = res.data
                    this.filterCampaignOptions = result
                    this.searchCampaignLoading = false
                },err => {
                    this.searchCampaignLoading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 缓存上一次选择
            handleCampaignFocus(val) {
                // if (val) {
                //     this.prev_campaign_id = this.form.campaign_id
                // }
            },
            // 所属广告系列 change 事件
            handleCampaignSelect(value) {
                if(this.prev_campaign_id != '') {
                    if(this.prev_campaign_id != value) {
                        this.$confirm('Modifying the campaign will clear all entered content', 'Prompt', {
                            confirmButtonText: 'Confirm',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                            }).then(() => {
                                this.form.campaign_id = value
                                this.prev_campaign_id = value
                                this.$refs.campaign_id.blur()
                                this.resetForm()
                                this.clearValidateItem('campaign_id')
                                this.getOutInfo(this.form.org_id, value)
                            }).catch(() => {
                                // this.loading = false
                                this.form.campaign_id = this.prev_campaign_id
                                this.$refs.campaign_id.blur()
                        });
                    }
                    
                }else{
                    // this.resetForm()
                    this.clearValidateItem('campaign_id')
                    this.form.campaign_id = value
                    this.prev_campaign_id = value
                    this.getOutInfo(this.form.org_id, value)
                }
                // this.form.campaign_id = value
                // if(value) {   
                // }else{
                //     this.resetForm()
                //     this.clearValidateItem('campaign_id')
                // }
            },
            getOutInfo(org_id, campaign_id) {
                this.editLoading = true
                let org_item = this.filterOrgOptions.filter(item=>item.org_id == org_id)
                this.$emit('postresult', {loading: false, dialog: true, success: false, org_list: {type:'group' ,list:org_item}})
                API.get_create_campaign_info({org_id: org_id, campaign_id: campaign_id}).then(res=>{
                    let result = res.data
                    this.tf_start.start_date = this.getMsgTime()
                    this.tf_start.start_time = '00:00:00'
                    this.supply_source = result.supply_source
                    this.daily_budget_currency = result.config.currency
                    this.daily_budget = result.daily_budget
                    // this.daily_budget = result.config.default_bid_amount
                    this.cpa_goal = result.config.cpa_goal
                    this.big_daily_budget = result.config['default_bid_amount']

                    this.countries_or_regions = result['countries_or_regions']
                    this.countries_or_regions_support_target = result['countries_or_regions_support_target']
                    this.form.time_zone = result.config['time_zone']
                    this.prev_start_time = result['start_time'] ? result['start_time'] : ''
                    this.prev_end_time = result['end_time'] ? result['end_time'] : ''
                    this.app_downloader_list = result['app_downloader_select_list'] ? result['app_downloader_select_list'].map(item=>{
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }) : []
                    this.sz_Form.app_downloader = this.app_downloader_list.length != 0 ? this.app_downloader_list[0]['value'] : ''
                    return result.adam_id
                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                }).then((adam_id)=>{
                    this.get_app_eligibility(adam_id, org_id).then(()=>{
                        this.editLoading = false
                    })
                })
            },
            get_app_eligibility(adam_id, org_id) {
                return API.get_create_app_eligibility({adam_id:adam_id, org_id: org_id}).then(res=>{
                    let result = res.data
                    let min_age = result[this.supply_source]['min_age']

                    let result_device_class = result[this.supply_source]['device_class']
                    let reres_device_list = []
                    let res_device = result_device_class ? Object.keys(result_device_class) : []
                    res_device.forEach(item=>{
                        reres_device_list.push({
                            value: item,
                            label: result_device_class[item]
                        })
                    })
                    this.device_class_list = reres_device_list
                    this.device_class = reres_device_list.map(item=>item.value)
                    
                    const res_startYear = Array.from({ length: 47 }, (_, index) => index + Number(min_age));
                    const res_endYear = Array.from({ length: 46 }, (_, index) => index + 19);
                    this.startYear = res_startYear
                    this.endYear = res_endYear


                }, err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info);
                })
            },
            // 广告组名称 change 事件
            handleAdName(event) {
                let result_value = event.target.value
                if(this.adname_mul) return
                this.validateItem('adgroup_name', result_value, 
                    [
                        { required: true, message: 'Required fields cannot be empty'},
                        {  max: 200, message: 'Maximum length is 200 characters'},
                        { reg: true,  message: 'Cannot input [];{}"<> or emojis'}
                    ]
                );
                // setTimeout(() => {
                //     if(this.errorsMsg['adgroup_name'] == '') {
                //         if(result_value != '') {
                //             this.adname_some(result_value)
                //         }
                //     }
                // }, 100);
            },
            handleAdNameInput:throttle(function(value) {
                // 在这里执行你的输入处理逻辑
                console.log('Input value:', value);
                this.adname_some(this.form.adgroup_name)
            }, 2200),
            // 校验广告组名称是否为空
            adname_some(adgroup_name) {
                return API.getPromotionAdgroupName({
                    campaign_id:this.form.campaign_id,
                    adgroup_name:adgroup_name,
                    adgroup_id:this.adgroup_id ? this.adgroup_id : ''
                }).then(res=>{
                    console.log('res', res)
                    this.adname_mul = false
                    return false
                },err=>{
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.adname_mul = true
                    this.errorsMsg['adgroup_name'] = err.info
                    return true
                    // 同一广告系列内广告组名称不可重复
                    // this.$message.error(err.info||'Request failed');
                })
            },
            // 投放日期tab切换
            handletfdate(value) {
                if(value == '1') {
                    this.form.end_time = ''
                    this.tf_end.start_date = ''
                    this.tf_end.start_time = ''
                    this.errorsMsg['tf_time_2'] = ''
                }
            },
            changeTimeZone(value) {
                this.form.time_zone = value
            },
            // 出价处理
            handleInput(val, name, limit = 2) {
                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                if(this.daily_budget_currency=='USD'&&name=='default_bid_amount'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='adgroup'&&item.field=='default_bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||2;
                }

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                this.form[name] = rval
            },
            // 关键词
            showKeywordModal(){
                this.$refs.keywordModal.showModal();
            },
            // 否定关键词
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            clearKeyword(){
                this.keyword = [];
            },
            clearNegativeKeyword(){
                this.negative_keyword = [];
            },
            // 选择我其他的app
            handleSelectOutApp() {
                let params = this.sz_Form.app_downloader_apps && this.sz_Form.app_downloader_apps.length == 0 ? [] : this.sz_Form.app_downloader_apps
                this.$refs.appModal.showModal(params, this.form.org_id)
            },
            // 投放日期选择
            handleDateState(value) {
                console.log(value)
                // this.tf_start.start_date = value
            },
            handleDateEnd(value) {
                console.log(value)
                // this.tf_end.start_date = value
            },
            // 投放时间选择
            handleTime(value) {
                console.log(value)
            },
            concat_start_date() {
                if(this.tf_start['start_date'] && this.tf_start['start_time']) {
                    this.form.start_time = `${this.tf_start['start_date']} ${this.tf_start['start_time']}`
                }else{
                    this.form.start_time = ''
                }
            },
            concat_end_date() {
                if(this.tf_end['start_date'] && this.tf_end['start_time']) {
                    this.form.end_time = `${this.tf_end['start_date']} ${this.tf_end['start_time']}`
                }else{
                    this.form.end_time = ''
                }
            },
            // 子组件吐出 时间段
            getdaypart(params) {
                this.form.daypart = params
            },
            // 默认最高每次点击出价
            handleamount(value) {
                // 走个请求
                if(value != '') {
                    API.get_create_app_am_config({org_id: this.form.org_id}).then(res=>{
                        let result = res.data
                        this.avg_default_bid_amount = result.avg_default_bid_amount
                    }, err=>{
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                    this.clearValidateItem('default_bid_amount')
                }
            },
            // 显示关键词
            showKeywordModal(){
                this.$refs.keywordModal.showModal();
            },
            saveKeyword(list){
                this.keyword = [...list];
            },
            // 显示否定关键词
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            saveNegativeKeyword(list){
                this.negative_keyword = [...list];
            },
            // 子组件吐出 选择app
            getOutApp(params) {
                this.sz_Form.app_downloader_apps = params
            },
            // 用户类型选择
            // 年龄 开始change
            handleAgeStart(value) {
                let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                if(Number(aend) < Number(this.ageForm.start)) {
                    this.errorsMsg['ageForm_start'] = 'Minimum age must be less than maximum age.'
                }else{
                    this.errorsMsg['ageForm_start'] = ''
                }
            },

            // 年龄 结束change
            handleAgeEnd(value) {
                let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                if(Number(aend) < Number(this.ageForm.start)) {
                    this.errorsMsg['ageForm_start'] = 'Minimum age must be less than maximum age.'
                }else{
                    this.errorsMsg['ageForm_start'] = ''
                }
            },
            // 国家 省 自治区
            remoteMethodCity(query, type) {
                if (query == '' || query.length == 1) {
                    this.countryOptions = []
                    this.areaOptions = []
                    this.localityOptions = []
                    return
                }
                let nums =  Object.keys(this.countries_or_regions) 
                let country_code = ''
                if(nums.length == 1) {
                    country_code = nums[0]
                }
                if(type == 'country') {
                    // 获取国家下拉框
                    this.searchCountryLoading = true
                    API.getPromotionCountryOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchCountryLoading = false
                        let reslute = res.data
                        this.countryOptions = reslute
                    }, err=>{
                        this.searchCountryLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }else if(type=='admin_area') {
                    // 获取省
                    this.searchAdminLoading = true
                    API.getPromotionAreaOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchAdminLoading = false
                        let reslute = res.data
                        this.areaOptions = reslute
                    }, err=>{
                        this.searchAdminLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }else if(type=='locality') {
                    // 获取城市
                    this.searchLocalityLoading = true
                    API.getPromotionLocalityOptions({search:query, org_id:this.form.org_id, country_code: country_code}).then(res=>{
                        this.searchLocalityLoading = false
                        let reslute = res.data
                        this.localityOptions = reslute
                    }, err=>{
                        this.searchLocalityLoading = false
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info);
                    })
                }
            },
            handleallchange(value, name) {
                if(value) {
                    this.clearValidateItem(name)
                }
            },
            valisubmitPromise() {
                const valiPro = new Promise((resolve, reject) => {
                    // let ispull = false
                    if(this.form.org_id == '') {
                        this.errorsMsg.org_id = this.errTips
                        reject()
                        return
                    }
                    if(this.form.campaign_id == '') {
                        this.errorsMsg.campaign_id = this.errTips
                        reject()
                        return
                    }
                    if(this.form.adgroup_name == '') {
                        this.errorsMsg.adgroup_name = this.errTips
                        reject()
                    }
                    if(this.adname_mul) {
                        this.errorsMsg.adgroup_name = 'Ad group names within the same campaign cannot be duplicated'
                        reject()
                    }
                    if(this.tfdate == '1') {
                        if(this.form.start_time == '') {
                            this.errorsMsg.tf_time = this.errTips
                            reject()
                        }else{
                            let prev_endtime = this.prev_end_time ? new Date(this.prev_end_time).valueOf() : 0
                            let startTims = new Date(this.form.start_time).valueOf()
                            console.log('prev_endtime', prev_endtime, startTims > prev_endtime)
                            if(prev_endtime != 0 && startTims > prev_endtime) {
                                this.errorsMsg.tf_time = 'Start date and time cannot exceed the end date and time of the parent campaign'
                                reject()
                            }
                        }
                    }


                    if(this.tfdate == '2') {
                        if(this.form.end_time == '') {
                            this.errorsMsg.tf_time_2 = this.errTips
                            reject()
                        }else{
                            let prev_starttime = this.prev_start_time ? new Date(this.prev_start_time).valueOf() : 0

                            let result_start = this.form.start_time ? new Date(this.form.start_time).valueOf() : 0
                            let result_end = this.form.end_time ? new Date(this.form.end_time).valueOf() : 0

                            if(result_start != 0 && result_end != 0) {
                                if(result_start >= result_end) {
                                    this.errorsMsg.tf_time = 'End date cannot be earlier than the start date and time'
                                    reject()
                                }else if(prev_starttime != 0 && prev_starttime > result_end) {
                                    this.errorsMsg.tf_time =  'End date and time cannot be earlier than the start date and time of the parent campaign'
                                    reject()
                                }
                            }
                        }
                    
                    }
                    if(this.tftime == '2' && this.supply_source == 'APPSTORE_SEARCH_RESULTS' && this.form.daypart.length == 0) {
                        this.errorsMsg.daypart = this.errTips
                        reject()
                    }
                    if(this.form.default_bid_amount == '') {
                        this.errorsMsg.default_bid_amount = this.errTips
                        reject()
                    }

                    if(Number(this.daily_budget) != 0 && Number(this.daily_budget) < Number(this.form.default_bid_amount)) {
                        this.errorsMsg.default_bid_amount = "Cannot exceed the parent campaign's budget, please re-enter"
                        reject()
                    }

                    if(Number(this.big_daily_budget)  < Number(this.form.default_bid_amount)){
                        reject()
                        this.errorsMsg.default_bid_amount = 'Cannot exceed the default maximum bid, please re-enter'
                    }


                    if(this.targeting_type == '2') {
                        let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2

                        if(this.device_class == '') {
                            this.errorsMsg.device_class = this.errTips
                            reject()
                        }
                        if(this.sz_Form.app_downloader == '') {
                            this.errorsMsg.app_downloader = this.errTips
                            reject()
                        }
                        if(this.sz_Form.app_downloader == '4' && this.sz_Form.app_downloader_apps.length == 0 ) {
                            this.errorsMsg.outApp = this.errTips
                            reject()
                        }
                        if(this.age_type == '2') {
                            if(this.ageForm.start == '') {
                                this.errorsMsg.ageForm_start = this.errTips
                                reject()
                            }
                            if(this.ageForm.end == '') {
                                this.errorsMsg.ageForm_end = this.errTips
                                reject()
                            }
                            let aend = this.ageForm.end == '65' ? 65 : this.ageForm.end
                            if(Number(aend) < Number(this.ageForm.start)) {
                                this.errorsMsg['ageForm_start'] = 'Minimum age must be less than maximum age.'
                                reject()
                            }
                        }
                        if(this.positioning_type == '2' && nums == 1 && this.countries_or_regions_support_target) {
                            if(this.positioningForm.country.length == 0 && this.positioningForm.admin_area.length == 0 && this.positioningForm.locality.length == 0) {
                                this.errorsMsg.country = this.errTips
                                reject()
                            }
                        }
                    }
                    resolve(true)
                })
                return valiPro
                // return ispull
            },
            handleSubmit(name, type) {
                this.valisubmitPromise().then(res=>{
                    this.adname_some(this.form.adgroup_name).then((adRes)=>{
                        if(adRes) {
                            this.$message.error('Form data contains errors. Please check and resubmit');
                        }else{
                            this.tofecth(name, type)
                        }
                    })
                }).catch(()=>{
                    this.$message.error('Form data contains errors. Please check and resubmit');
                })

            },
            tofecth(name, type) {
                let params = {}
                if(this.supply_source == 'APPSTORE_SEARCH_RESULTS') {
                    params['cpa_goal'] = this.form.cpa_goal
                    
                }
                
                if(this.tfdate == '2') {
                    params['end_time'] = this.form.end_time
                }
                if(this.tftime == '2') {
                    params['daypart'] = this.form.daypart
                }
                if(this.targeting_type == '2') {
                    let nums = Array.isArray(Object.keys(this.countries_or_regions)) ? Object.keys(this.countries_or_regions).length : 2

                    params['device_class'] = this.device_class
                    params['app_downloader'] = this.sz_Form.app_downloader

                    if(this.sz_Form.app_downloader == '4') {
                        params['app_downloader_apps'] = this.sz_Form.app_downloader_apps.map(item=>item.adam_id)
                    }
                    if(this.age_type == '2') {
                        let age = []
                        if(this.ageForm.end == '65') {
                            age = [this.ageForm.start]
                        }else{
                            age = [this.ageForm.start, this.ageForm.end]
                        }
                        params['age'] = age
                    }
                    
                    if(this.positioning_type == '2' && nums == 1 && this.countries_or_regions_support_target) {
                        params['country'] = this.positioningForm.country 
                    }
                    if(this.positioning_type == '2'  && nums == 1 && this.countries_or_regions_support_target) {
                        params['admin_area'] = this.positioningForm.admin_area 
                    }
                    if(this.positioning_type == '2'  && nums == 1 && this.countries_or_regions_support_target) {
                        params['locality'] = this.positioningForm.locality 
                    }
                }
                if(this.supply_source == 'APPSTORE_PRODUCT_PAGES_BROWSE') {
                    params['app_categories'] = this.form.app_categories
                }
                if(this.supply_source == 'APPSTORE_SEARCH_RESULTS') {
                    params['automated_keywords_opt_in'] = this.form.automated_keywords_opt_in
                }
                if(this.apple_create_type != 'editGroup' && this.negative_keyword.length != 0) {
                    let res_negativeKeyword = this.negative_keyword.map(item=>{
                        return {
                            text:item.key_word_text,
                            match_type:item.match_type=='Exact Match'?'EXACT':(item.match_type=='Broad Match'?'BROAD':''),
                        }
                    });
                    params['negative_keyword'] = JSON.stringify(res_negativeKeyword);
                }

                if(this.apple_create_type != 'editGroup' && this.keyword.length != 0) {
                    let res_keyword = this.keyword.map(item=>{
                        return {
                            text:item.key_word_text,
                            bid_amount:item.bid_amount,
                            match_type:item.match_type=='Exact Match'?'EXACT':(item.match_type=='Broad Match'?'BROAD':''),
                        }
                    });
                    params['keyword'] = JSON.stringify(res_keyword);
                }

                params['time_zone'] = this.form.time_zone
                params['default_bid_amount'] = this.form.default_bid_amount
                params['org_id'] = this.form.org_id
                params['campaign_id'] = this.form.campaign_id
                params['adgroup_name'] = this.form.adgroup_name
                params['start_time'] = this.form.start_time
                params['gender'] = this.sz_Form.gender
                console.log('保存结果', params)


                
                
                let currency_time = new Date().valueOf()
                let current_name = `ads_${currency_time}`
                
                if(this.apple_create_type == 'editGroup') {
                    this.dialogVisible = true
                    this.dialogTypeTitle= 'Editing Ad Group, processing…'
                    let editInfo = this.$store.getters.apple_edit_info
                    params['adgroup_id'] = editInfo['adgroup_id']
                    API['adgroup_edit_adgroup'](params,{
                        timeout: 120*1000,
                    }).then(res=>{
                        let resultData = res.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''

                        // 单个请求成功
                        let flag_single_post_html = get_flag_suc_html(res['info'], '')
                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: flag_single_post_html
                        });
                        // this.$emit('postresult', {loading: false, dialog: false, success: true, type:type,org_list: {type:'group' ,list:[]}})
                        this.$emit('postresult', {loading: false, dialog: false, success: true, type:type, org_list: {type:'group' ,list:[]}})
                    }, err=>{
                        let resultData = err.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''
                        if(err.code =='403'){
                            this.$confirm(err.info, 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {});
                                return          
                        }
                        // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                        let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'],[],[],current_name );

                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: flag_mul_err_html
                        });
                        this.$store.commit('apple/ADD_NOTIFY', {
                            id: `${current_name}_close`,
                            value: current_tip,
                        });
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, type:type, org_list: {type:'group' ,list:org_item}})
                        
                    })
                }else{
                    this.dialogVisible = true
                    this.dialogTypeTitle= 'Creating Ad Group, processing…'

                    API[name](params,{
                        timeout: 120*1000,
                    }).then(res=>{
                        let resultData = res.data
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle= ''

                        // 单个请求成功
                        let flag_single_post_html = get_flag_suc_html(res['info'], '')
                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: flag_single_post_html
                        });

                        this.$emit('postresult', {loading: false, dialog: false, success: true, type:type,org_list: {type:'group' ,list:[]}})
                    }, err=>{
                        let resultData = err.data||{};
                        // 处理多个个请求中 关闭
                        this.dialogVisible = false
                        this.dialogTypeTitle = ''
                        if (err.code == '403') {
                            this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }

                        let campData = resultData.data||{};
                        let isCreateCampSuccess = campData.campaign_id&&campData.campaign_name;

                        let keywordErrList = resultData.keyword_err_list||[];
                        let negativeKeywordErrList = resultData.negative_keyword_err_list||[];


                        // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                        let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'], keywordErrList, negativeKeywordErrList,current_name );

                        let current_tip = this.$notify({
                            showClose: false,
                            duration: 0,
                            dangerouslyUseHTMLString: true,
                            message: flag_mul_err_html
                        });
                        this.$store.commit('apple/ADD_NOTIFY', {
                            id: `${current_name}_close`,
                            value: current_tip,
                        });
                        let org_item = this.filterOrgOptions.filter(item=>item.org_id == this.form.org_id)
                        this.$emit('postresult', {loading: false, dialog: false, success: false, type:type, org_list: {type:'group' ,list:org_item}})
                    })
                }
            }
        }

    }
    
</script>
<style lang="scss" scoped>
.apple_group{
    .create_list{
        background-color: #fff;
        padding: 10px;
        margin-bottom: 20px;
        .create_title{
            font-size: 14px;
            padding-bottom: 10px;
            padding-left: 20px;
        }
        .create_item{
            display: flex;
            align-items: center;
            padding-bottom: 30px;
            .create_label{
                flex: 0 0 250px;
                text-align: left;
                white-space: nowrap;
                .star{
                    color: #ff0000;
                    font-size: 16px;
                    display: inline-block;
                    vertical-align: middle;
                    padding-right: 4px;
                    padding-left: 20px;
                }
                .create_label_text{
                    font-size: 12px;
                    display: inline-block;
                    color: #606266;
                    
                }
            }
            .create_action{
                flex: 0 0 450px; 
                position: relative;
                .create_err_bottom{
                    color: #ff0000;
                    position: absolute;
                }
                .posi{
                    position: absolute;
                }
            }
            .create_err_right{
                flex: auto; 
                display: inline-block;
                color: #ff0000;
            }
            .questions {
                width: 12px;
                height: 12px;
                line-height: 14px;
                text-align: center;
                border-radius: 10px;
                background-color: #333;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                margin-left: 2px;
                cursor: pointer;
            }
            .ad_name_flex{
                display: flex;
                align-items:center;
                .num_length{
                    padding-left:10px;
                    font-size: 12px;
                    color: #606266;
                    flex: 0 0 60px;
                }
            }
        }
    }
    .create_divider{
        background-color:#fff;
        border-bottom: 1px solid #d9d9d9;
        padding: 12px 10px;
    }
    .width460{
        width: 460px;
    }
}
</style>
